module.exports = __webpack_public_path__ + "static/media/blue-grey-s-10.957a11de.png";